import { LinearGradient } from "expo-linear-gradient";
import { Pressable, Text, StyleSheet, View } from "react-native";

import { colors, fonts, spacing, radius, shadows, gradients } from "@/lib/theme";

interface SubmitButtonProps {
    allComplete: boolean;
    inline?: boolean;
    disabled?: boolean;
    onPress: () => void;
    loading?: boolean;
    label?: string;
}

export function SubmitButton({
    allComplete,
    inline = false,
    disabled = false,
    onPress,
    loading,
    label = "SUBMIT & CLOCK OUT"
}: SubmitButtonProps) {
    if (allComplete) {
        return (
            <View style={inline ? styles.inlineContainer : styles.container}>
                <Pressable
                    accessibilityRole="button"
                    accessibilityState={{ disabled: disabled || !!loading }}
                    onPress={onPress}
                    disabled={disabled || loading}
                    style={({ pressed }) => [pressed && styles.pressed]}
                >
                    <LinearGradient
                        colors={gradients.brand}
                        start={{ x: 0, y: 0 }}
                        end={{ x: 1, y: 1 }}
                        style={[styles.button, shadows.brand]}
                    >
                        <Text style={styles.buttonTextWhite}>{label}</Text>
                    </LinearGradient>
                </Pressable>
            </View>
        );
    }

    // Muted state — still tappable, shows error toast
    return (
        <View style={inline ? styles.inlineContainer : styles.container}>
            <Pressable
                accessibilityRole="button"
                accessibilityState={{ disabled: disabled || !!loading }}
                disabled={disabled || loading}
                onPress={onPress}
                style={({ pressed }) => [styles.buttonMuted, pressed && styles.pressed]}
            >
                <Text style={styles.buttonTextMuted}>{label}</Text>
            </Pressable>
        </View>
    );
}

const styles = StyleSheet.create({
    inlineContainer: { marginTop: spacing.md, marginBottom: spacing.xl },
    container: {
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        paddingHorizontal: spacing.base,
        paddingBottom: spacing.xl,
        paddingTop: spacing.md,
        backgroundColor: colors.background
    },
    button: {
        height: 56,
        borderRadius: radius.full,
        alignItems: "center",
        justifyContent: "center"
    },
    buttonMuted: {
        height: 56,
        borderRadius: radius.full,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: colors.gray200
    },
    buttonTextWhite: {
        fontFamily: fonts.bold,
        fontSize: 14,
        color: "#FFFFFF",
        letterSpacing: 0.5
    },
    buttonTextMuted: {
        fontFamily: fonts.bold,
        fontSize: 14,
        color: colors.gray400,
        letterSpacing: 0.5
    },
    pressed: {
        opacity: 0.9,
        transform: [{ scale: 0.98 }]
    }
});
